module.exports = __webpack_public_path__ + "static/Column-Resizing-b2bcb28de1bd82ef2c751e1cad766355.png";